import React, { useState } from "react";
import { sendWhatsAppMessage } from "../../services/adminUserService";

const WhatsAppMessageModal = ({ user, onClose }) => {
 const [message, setMessage] = useState("");
 const [sending, setSending] = useState(false);

 const predefinedMessages = [
 "Hi! Your session is starting soon. Please join on time.",
 "Thank you for being part of our speaking club! How was your experience?",
 "Reminder: You have an upcoming session scheduled.",
 "We've added bonus sessions to your account. Enjoy!",
 "Welcome to our speaking club! Feel free to reach out if you need help."
 ];

 const handleSend = async () => {
 if (!message.trim()) {
 alert("Please enter a message");
 return;
 }

 setSending(true);
 try {
 await sendWhatsAppMessage(user.id, message);
 alert("WhatsApp message sent successfully!");
 onClose();
 } catch (error) {
 alert("Failed to send message. Please try again.");
 } finally {
 setSending(false);
 }
 };

 const selectPredefinedMessage = (msg) => {
 setMessage(msg);
 };

 return (
 <div className="modal-overlay" onClick={onClose}>
 <div className="whatsapp-modal" onClick={(e) => e.stopPropagation()}>
 <div className="modal-header">
 <h3>Send WhatsApp Message</h3>
 <button className="close-btn" onClick={onClose}>×</button>
 </div>

 <div className="user-info">
 <div className="user-details">
 <img src={user.picture} alt={user.name} className="user-avatar" />
 <div>
 <p><strong>{user.name}</strong></p>
 <p>{user.whatsappNumber}</p>
 </div>
 </div>
 </div>

 <div className="predefined-messages">
 <h4>Quick Messages:</h4>
 <div className="message-buttons">
 {predefinedMessages.map((msg, index) => (
 <button
 key={index}
 className="predefined-btn"
 onClick={() => selectPredefinedMessage(msg)}
 >
 {msg.substring(0, 50)}...
 </button>
 ))}
 </div>
 </div>

 <div className="message-input">
 <label>Message:</label>
 <textarea
 value={message}
 onChange={(e) => setMessage(e.target.value)}
 placeholder="Type your message here..."
 rows={4}
 maxLength={1000}
 disabled={sending}
 />
 <div className="char-count">
 {message.length}/1000 characters
 </div>
 </div>

 <div className="modal-actions">
 <button className="btn-cancel" onClick={onClose} disabled={sending}>
 Cancel
 </button>
 <button 
 className="btn-send" 
 onClick={handleSend} 
 disabled={sending || !message.trim()}
 >
 {sending ? "Sending..." : "Send Message"}
 </button>
 </div>
 </div>
 </div>
 );
};

export default WhatsAppMessageModal;